var map = {
	"./icon_attribute_cool.png": "5f63",
	"./icon_attribute_cute.png": "9165",
	"./icon_attribute_happy.png": "0c76",
	"./icon_attribute_mysterious.png": "d234",
	"./icon_attribute_pure.png": "a984"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "278c";